import { Navigate, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import { UserOnboardingWizard } from '../components/onboarding/UserOnboardingWizard'

export function Welcome() {
  const navigate = useNavigate()
  const token = useAuthStore((s) => s.token)
  const username = useAuthStore((s) => s.username)

  if (!token || !username) return <Navigate to="/login" replace />
  if (sessionStorage.getItem('abaddon-onboarding-pending') !== '1') {
    return <Navigate to={`/~${username}/journal`} replace />
  }

  function handleComplete() {
    navigate(`/~${username!}/journal`, { replace: true })
  }

  return (
    <div style={{ maxWidth: 520, margin: '4rem auto', padding: '2rem' }}>
      <UserOnboardingWizard onComplete={handleComplete} />
    </div>
  )
}
